import { UserAnswerConstants as Constants, QuizResult } from "../constants";
import { answerApi as api } from "../../api";

export const userAnswerAction = {
  storeMultipleAnswers,
  checkUserProgress,
  getQuizResult,
};

function storeMultipleAnswers(data) {
  return async (dispatch) => {
    dispatch(request());
    return new Promise((resolve, reject) => {
      api._storeMultipleAnswers(data).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed to submit or update answers."));
          reject(error);
        }
      );
    });
  };

  function request() {
    return { type: Constants.LOADING };
  }

  function success(payload) {
    return { type: Constants.STORE_OR_UPDATE_MULTIPLE, payload };
  }

  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function checkUserProgress(data) {
  return async (dispatch) => {
    dispatch(request());
    return new Promise((resolve, reject) => {
      api._checkUserProgress(data).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed to fetch progress."));
          reject(error);
        }
      );
    });
  };

  function request() {
    return { type: Constants.LOADING };
  }

  function success(payload) {
    return { type: Constants.CHECK_USER_PROGRESS, payload };
  }

  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function getQuizResult(slug) {
  return async (dispatch) => {
    return new Promise((resolve, reject) => {
      api._getQuizResult(slug).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed to fetch quiz result."));
          reject(error);
        }
      );
    });
  };

  function success(payload) {
    return { type: QuizResult.QUIZRESULT_SUCCESS, payload };
  }

  function failure(error) {
    return { type: QuizResult.QUIZRESULT_FAILED, error };
  }
}
